import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { setReferralCookie } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [validating, setValidating] = useState(true);

  useEffect(() => {
    const handleReferral = async () => {
      try {
        // Validate the referral code
        const response = await axios.get(`${API_URL}/api/r/${code}`);
        
        if (response.data.valid) {
          // Set the referral cookie for 30 days
          setReferralCookie(code);
        }
        
        // Always redirect to signup
        navigate('/signup', { replace: true });
      } catch (error) {
        console.error('Referral validation error:', error);
        // Still redirect to signup even on error
        navigate('/signup', { replace: true });
      }
    };

    if (code) {
      handleReferral();
    } else {
      navigate('/signup', { replace: true });
    }
  }, [code, navigate]);

  if (validating) {
    return (
      <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0a2540] mx-auto mb-4"></div>
          <p className="text-slate-600">Redirecting...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default ReferralRedirect;
